
import React from 'react'
import { useTranslation } from "react-i18next";
import Section1 from "../../containers/HomePage/Section1/Section1"
import Section2 from "../../containers/HomePage/Section2/Section2"
import Section3 from "../../containers/HomePage/Section3/Section3"
import Section4 from '../../containers/HomePage/Section4/Section4';
import Section5 from '../../containers/HomePage/Section5/Section5';
const HomePage = () => {
    const { t } = useTranslation();
    return  <div className='m-2-b'>
        <div fluid className="bg-black">
            <Section1 />
        </div>
        <div fluid className="bg-whtie p-1">
            <Section2 />
        </div>
        <div fluid className="bg-whtie p-1">
            <Section3 />
        </div>
        
        <div fluid className="bg-whtie p-1-t p-1-b">
            <Section4 />
        </div> 
    </div>
}
export default HomePage